//Capitalizes only the first letter in a sentence eg. ALL CAPS => All caps

export default function toSentenceCase(string: string): string {
	return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}
